import idx from 'idx'
import { capitalize, isEmpty, isObject } from 'lodash'

import { db } from 'data'

export default function createReport(fieldReportId) {
  return db.getReport(fieldReportId).then((snapshot) => {
    const fieldReport = snapshot.val()

    const { assessorEmail, creationDate, images, title } = fieldReport

    if (!creationDate || isEmpty(images)) return

    let report = {}
    let pdfUrl = null
    let unassessedItems = {}

    const imagePromises = []

    Object.keys(images).forEach((imageId) => {
      const image = images[imageId]
      const { imageRef, settings: imageData } = image

      const unassessedItem = {
        category: capitalize(idx(imageData, (_) => _.category)) || 'Unknown',
        conditionNumber: idx(imageData, (_) => _.conditionNumber) || null,
        id: imageId,
        imageRef,
        lat: idx(imageData, (_) => _.lat) || null,
        lon: idx(imageData, (_) => _.lon) || null,
      }

      const imageHandler = (() => {
        return (response) => {
          unassessedItem.imageUrl = response

          unassessedItems = {
            ...unassessedItems,
            [imageId]: {
              ...unassessedItem,
            },
          }
        }
      })(imageId)

      const imagePromise = db.getImageURL(imageRef)
        .then(imageHandler)
        //.catch((error) => console.log('error', error))
        .catch(() => Promise.resolve(null))

      imagePromises.push(imagePromise)
    })

    const pdfPromise = db.getReportPdfUrl(fieldReportId)
      .then((response) => {
        pdfUrl = response
        return pdfUrl
      }, () => {
        return Promise.resolve(null)
      })
      .catch((error) => {
        //console.log('error', error)
      })

    return Promise.all(imagePromises.concat(pdfPromise)).then(() => {
      const firstUnassessedItem = unassessedItems[Object.keys(unassessedItems)[0]]

      if (isEmpty(firstUnassessedItem)) return

      report = {
        id: fieldReportId,
        title,
        assessmentDateStart: creationDate,
        assessorEmail,
        coverImageRef: firstUnassessedItem.imageRef,
        coverImageUrl: firstUnassessedItem.imageUrl,
        creationDate,
        lat: firstUnassessedItem.lat,
        lon: firstUnassessedItem.lon,
        type: 'Field Report',
        // schema purposes only—firebase won't store these
        areas: {},
        sites: {},
        objects: {},
        unassessedItems,
        images,
        pdfUrl,
        fieldReport,
        createReportVersion: 2,
      }

      if (isObject(report)) {
        db.createOrUpdateFullReport(fieldReportId, report)

        return report
      }
    })
  })
}


// WEBPACK FOOTER //
// ./src/libs/create-report.js